<template>
  <a-modal title="附件管理"
           :width="800"
           :visible="visible"
           :maskClosable="false"
           @cancel="handleCancel"
           @ok="handleOk"
           destroyOnClose
           :confirmLoading="loading"
           :footer="null"
  >
    <a-row v-show="referId && referId !== ''" style="margin: 8px;">
      <a-col :span="24">
        <div style="display: flex;justify-content: space-between">
          <a-alert type="info" show-icon message="拖动附件可进行排序"/>
          <div>
                    <span>
                        <a-button v-if="isEdit" :id="'AttachButton' + _uid" type="primary" icon="upload"
                                  :loading="configLoading">
                        上传文件
                        </a-button>
                    </span>
            <span v-if="uploadCount>0">
                        <a-button class="ml-3" type="primary" icon="download" @click="onDownloadAll()">
                        一键下载
                        </a-button>
                    </span>
          </div>
        </div>
        <div class="file_head">
          <div class="w-100">文件名</div>
          <div class="flex-0">大小</div>
          <div class="flex-0" style="flex: 0 0 120px">操作</div>
        </div>
        <draggable element="div" :disabled="false" v-model="uploadFiles" @change="onChangeFilesOrder">
          <div v-for="(file, idx) in uploadFiles" :key="file.id" class="file_list">
            <div class="w-100">
              <a-tooltip overlayClassName="file_bgc_tooltip" placement="left"
                         :title="'上传用户：'+file.userName+' 上传时间：'+file.addDate">
                <a class="color-main" @click="onView(idx)">{{ file.name }}</a>
              </a-tooltip>
            </div>
            <div class="flex-0">
              <span v-if="hasError" style="color:red">{{ file.response }}</span>
              <span v-else>{{ file.size }}</span>
            </div>
            <div class="flex-0" style="flex: 0 0 120px">
              <div class="download">
                <a class="color-main" @click="onDownloadOne(file)">[下载]</a>
              </div>
              <div class="delete">
                <a-popconfirm
                    v-show="isDelete(file)"
                    title="是否确认删除?" @confirm="onDelete(file.id)">
                  <a>[删除]</a>
                </a-popconfirm>
              </div>
            </div>
            <div class="progress">
              <div v-show="file.percent < 100" :style="{width:file.percent + '%'}"></div>
            </div>
          </div>
        </draggable>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import draggable from 'vuedraggable'
import {ACCESS_TOKEN} from '@/store/mutation-types'
import plupload from 'plupload'
import moment from 'moment'
import qs from 'qs'

export default {
  name: 'UploadIndexModal',
  components: {
    draggable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    referId: {
      type: String,
      required: true,
      default: ''
    },
    configKey: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    mangerReadonly: {
      type: Boolean,
      required: false,
      default: false
    },
    // 是否有操作权限（根据各模块的实际情况）
    hasRight: {
      type: Boolean,
      required: false,
      default: false
    },
    selfUpdate: {
      type: Boolean,
      required: false,
      default: true
    },
    // 是否获取此业务caseId所有相关的附件
    isAllCase: {
      type: Boolean,
      required: false,
      default: false
    },
    // 排除的附件key，一般与 isAllCase 同时使用
    notConfigKeys: {
      required: false,
      default: () => { return [] }
    },
    max: {
      type: Number,
      required: false,
      default: 99
    },
    // 此字段仅用作融合到 Form 检验必须上传功能
    value: {
      type: String
    },
    zipTitle: {
      type: String,
      required: false,
      default: ''
    },
    canUpload: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.loadConfig()
    this.refreshData()

    // 是否有管理权限
    if (!this.readonly || this.hasRight || this.user.permissions['case.attach.super.manager']) {
      this.isEdit = true
    }

    if ((this.readonly && !this.user.permissions['case.attach.super.manager']) || (this.mangerReadonly && this.mangerReadonly === true)) {
      this.isEdit = false
    }

    // 没有权限，但是有上传按钮，能上传文件
    if (this.canUpload) {
      this.isEdit = true
    }

    this.$emit('HasEdit', this.isEdit)
  },
  computed: {
    isDelete() {
      return function (file) {
        let isFlag = false
        // 在可编辑的前提之下，需判断是否为个人上传的控制
        if (this.isEdit && (!this.selfUpdate || (this.selfUpdate && file.userId === this.user.id) || this.hasRight || this.user.permissions['case.attach.super.manager'])) {
          isFlag = true
        }
        return isFlag
      }
    }
  },
  watch: {
    referId(val) {
      this.refreshData()
    }
  },
  data() {
    return {
      user: this.$ls.get('user'),
      isEdit: false,
      access_token: '',
      configLoading: true,
      uploading: false,
      hasError: false,
      config: null,
      uploadFiles: [],
      file_fixs: ['pdf', 'docx', 'doc', 'xlsx', 'xls', 'ofd', 'wps', 'wpt', 'et', 'ett'],
      form: this.$form.createForm(this),
      loading: false,
      uploadCount: 0,
      uploadFileObj: {}
    }
  },
  methods: {
    moment,
    loadConfig() {
      const that = this
      that.$http.get('/api/1/attachment/config.json?key=' + that.configKey).then(function (response) {
        if (response.code === 200) {
          that.configLoading = false
          that.config = response.result
          that.initUploader()
        }
      })
    },
    onView(idx) {
      let file = this.uploadFiles[idx]
      file.referId = this.referId
      file.configKey = this.configKey
      file.hasRight = this.hasRight
      this.onAttView(file)
    },
    onAttView(file) {
      window.open(file.url)
    },
    onChangeFilesOrder() {
      let ids = []
      this.uploadFiles.forEach(item => ids.push(item.id))
      this.$http.post('/api/1/attachment/reorder.json', qs.stringify({ids: ids.join(',')}))

      this.sendEvent()
    },
    getFileIndex(id) {
      return this.uploadFiles.findIndex(item => item.id === id)
    },
    refreshData() {
      const that = this
      if (!that.referId) {
        return
      }
      let configKey = that.configKey
      if (that.isAllCase) {
        configKey = ''
      }

      that.$http.get('/api/1/attachment/attachments.json?referId=' + that.referId + '&configKey=' + configKey).then(function (response) {
        if (response.code === 200) {
          let files = []

          response.result.forEach(item => {
            if (!that.notConfigKeys.includes(item.keyword)) {
              let fileObj = {
                id: item.id,
                name: item.name,
                userId: item.userId,
                userName: item.extras.userName,
                addDate: moment(item.addDate).format('YYYY-MM-DD HH:mm'),
                addDateL: moment(item.addDate).format('YYYY-MM-DD HH:mm:ss'),
                extension: item.extension,
                size: item.sizeDesc,
                percent: 100,
                response: null,
                clazz: 'ant-upload-list-item-done',
                url: process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + item.id
              }
              files.push(fileObj)
            }
          })
          that.uploadFiles = files
          if (that.uploadFiles.length > 0) {
            that.sendEvent()
          }
        }
      })
    },
    onDelete(fileId) {
      const that = this
      that.$http.get('/api/1/attachment/delete.json?id=' + fileId).then(function (response) {
        if (response.code === 200) {
          that.uploadFiles = that.uploadFiles.filter(file => file.id !== fileId)
        }
        that.sendEvent()
      })
    },
    initUploader() {
      const that = this
      let mimeTypes = []
      let mime = that.config.extension.join(',')
      if (!mime.includes('***')) {
        mimeTypes.push({title: '文件类型', extensions: mime.split('|').join(',')})
      }
      const uploader = new plupload.Uploader({
        headers: {'X-Auth-Token': that.$ls.get(ACCESS_TOKEN)},
        runtimes: 'html5,flash,html4',
        browse_button: 'AttachButton' + that._uid,
        url: that.$_c + 'api/1/attachment/plupload.json',
        flash_swf_url: '../../../static/plupload/2.3.6/Moxie.swf',
        filters: {
          mime_types: mimeTypes,
          max_file_size: (that.config.maxSize / 1024) + 'kb',
          prevent_duplicates: false
        },
        init: {
          BeforeUpload: function () {
            uploader.setOption('multipart_params', {referId: that.referId, key: that.configKey})
          },
          FilesAdded: function (up, files) {
            that.$emit('change', '1')
            if (that.uploadFiles.length >= that.max) {
              that.$warning({title: '最多上传 ' + that.max + ' 个文件'})
              return
            }
            plupload.each(files, function (file) {
              that.uploadFiles.push({
                id: file.id,
                name: file.name,
                userId: that.user.id,
                userName: that.user.name,
                addDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
                addDateL: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                size: plupload.formatSize(file.size),
                percent: 1,
                response: null,
                clazz: 'ant-upload-list-item-uploading'
              })
            })
            that.uploading = true
            uploader.start()
          },
          UploadProgress: function (up, file) {
            const idx = that.getFileIndex(file.id)
            if (idx < 0) {
              return
            }
            that.uploadFiles[idx].percent = file.percent
          },
          FileUploaded: function (up, file, info) {
            let text = info.response
            let result = /<pre[^>]*>(.*?)<\/pre>/g.exec(info.response)
            if (result) {
              text = result[1]
            }
            let response = JSON.parse(text)
            const idx = that.getFileIndex(file.id)
            if (response.error) {
              that.hasError = true
              that.uploadFiles[idx].percent = file.percent
              that.uploadFiles[idx].response = response.error.message
              that.uploadFiles[idx].clazz = 'ant-upload-list-item-error'
              that.uploadFiles[idx].extension = file.name.split('.').pop()
            } else {
              that.uploadFiles[idx].id = response.id
              that.uploadFiles[idx].percent = file.percent
              that.uploadFiles[idx].response = null
              that.uploadFiles[idx].clazz = 'ant-upload-list-item-done'
              if (response.isExternal === 1) {
                that.uploadFiles[idx].url = response.result
              } else {
                that.uploadFiles[idx].url = process.env.VUE_APP_WEB_SERVER + '/api/1/attachment/download?id=' + response.id
              }
              that.uploadFiles[idx].extension = file.name.split('.').pop()
            }

            that.sendEvent()
          },
          UploadComplete: function (up, files) {
            that.uploading = false
          },
          Error: function (up, err) {
            that.uploading = false
            that.$message.error(err.message)
          }
        }
      })
      uploader.init()
    },
    sendEvent() {
      this.uploadCount = this.uploadFiles.length
      if (this.uploadFiles.length === 0) {
        this.$emit('change', '', null)
      } else {
        this.uploadFileObj = this.uploadFiles[0]
        this.$emit('change', this.uploadCount, this.uploadFileObj)
      }
    },
    onDownloadOne(file) {
      const that = this
      that.$http.get('/api/v2/attachment/check_exist.json?referId=' + this.referId + '&configKey=' + this.configKey + '&id=' + file.id).then(function (response) {
        if (response.result === '1') {
          if (window.isbigant) {
            if (file.extension === 'pdf') {
              window.openBigAnt.OpenBySystem(process.env.VUE_APP_API_SERVER + '/api/1/ntko/att_file_down?id=' + file.id)
            } else {
              window.openBigAnt.OpenByIE(process.env.VUE_APP_API_SERVER + '/api/1/attachment/download?id=' + file.id)
            }
          } else {
            if (file.extension === 'pdf') {
              window.open(that.$_c + 'api/1/ntko/att_file_down?id=' + file.id)
            } else {
              window.open(that.$_c + 'api/1/attachment/download?id=' + file.id)
            }
          }
        } else {
          that.$error({content: '该附件不存在,下载失败！'})
        }
      })
    },
    onDownloadAll() {
      let configKey = this.configKey
      if (this.isAllCase) {
        configKey = ''
      }
      // 文件夹名称 替换过滤特殊字符
      let newZipTitle = ''
      if (this.zipTitle && this.zipTitle !== '') {
        newZipTitle = this.zipTitle.replace(/[\\\\/:*?\\<>|]/g, '_')
        newZipTitle = encodeURIComponent(encodeURIComponent(newZipTitle))

        //newZipTitle = encodeURI(encodeURI(newZipTitle))// 前台用encodeURI（）方法对中文参数进行两次转码
      }

      let dUrl = 'api/v2/attachment/batch_download?referId=' + this.referId + '&configKey=' + configKey + '&zipTitle=' + newZipTitle
      window.open(this.$_c + dUrl)
    },
    handleOk() {
      this.$emit('success', this.uploadCount)
    },
    handleCancel() {
      this.$emit('cancel', this.uploadCount)
    },
    windowOpenFocus(url, id, idType) { // 处理打开正文附件打开，当打开后，不管页面怎么操作，再次点击时，会将原来打开的弹出来
      var open_obj = null // 打开的正文
      var is_open_zw = false // 判断正文是否被打开过
      var case_id = id
      var ntko_width = window.screen.width
      var ntko_height = window.screen.height - 50
      if (window.openWinObj.length !== 0) {
        window.openWinObj.forEach(function (item) {
          var is_true = true
          try {
            if (idType === 'attachmentId') {
              item.attachmentId
            } else {
              item.attId
            }
          } catch (e) {
            is_true = false
          }
          if (is_true) {
            if (idType === 'attachmentId') {
              if (case_id === item.attachmentId) { // 表示该正文被打开过。
                is_open_zw = true
                open_obj = item
              }
            } else {
              if (case_id === item.attId) { // 表示该正文被打开过。
                is_open_zw = true
                open_obj = item
              }
            }
          }
        })

        if (open_obj !== null && is_open_zw && !open_obj.closed) { // 窗口没被关闭
          open_obj.focus()
        } else { // 重新打开
          window.openWinObj.forEach(function (item, index) {
            var is_true_del = true
            try {
              if (idType === 'attachmentId') {
                item.attachmentId
              } else {
                item.attId
              }
            } catch (e) {
              is_true_del = false
            }
            if (is_true_del) {
              if (idType === 'attachmentId') {
                if (case_id === item.attachmentId) {
                  window.openWinObj.splice(index, 1) // 删除对应数据
                }
              } else {
                if (case_id === item.attId) {
                  window.openWinObj.splice(index, 1) // 删除对应数据
                }
              }
            } else {
              window.openWinObj.splice(index, 1) // 删除对应数据
            }
          })
          this.msgWindow = window.open(url, id, 'height=' + ntko_height + ', width=' + ntko_width + ', top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=yes,status=no')
          window.openWinObj.push(this.msgWindow)
        }
      } else { // 第一次打开的
        this.msgWindow = window.open(url, id, 'height=' + ntko_height + ', width=' + ntko_width + ', top=0,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=yes,status=no')
        window.openWinObj.push(this.msgWindow)
      }
    }
  }
}
</script>

<style scoped lang="less">
.color-main {
  color: #1890ff !important;
}

.file_head {
  display: flex;
  background: #f1f1f1;
  padding: 8px 12px;
  border: 1px solid #e6e6e6;
  border-bottom: none;
  margin-top: 12px;
  color: #000;
  font-weight: bold;
  font-size: 15px;
}

.file_list {
  padding: 8px 12px;
  display: flex;
  position: relative;
  line-height: 20px;
  border: 1px solid #e6e6e6;
  border-top: none;
  font-size: 15px;
}

.w-100 {
  width: 100%;
}

.flex-0 {
  display: flex;
  flex: 0 0 100px;
  justify-content: center;
}

.file_list a {
  display: block;
}

.progress {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: #e8e8e8
}

.progress div {
  height: 2px;
  background: #52c41a
}

.file_list .delete {
  position: relative;
  margin-left: 8px;
}

.file_list .delete:hover i {
  color: #ff0000;
  cursor: pointer;
}

.file_list > span {
  margin-right: 50px;
  flex: 0 0 auto;
}

.table-upload td {
  position: relative;
}
</style>
